import React, { Fragment } from 'react';
import './CouponDisplay.scss';

import { Tag } from 'primereact/tag';
import { UserCouponWithCoupon, UserCouponWithCouponAndUsesCount } from '../../types/coupon';
import { classNames } from 'primereact/utils';
import { InfoIcon } from '../InfoIcon/InfoIcon';

interface Props {
  coupon: UserCouponWithCoupon | UserCouponWithCouponAndUsesCount | undefined;
  className?: string;
  loading?: boolean;
  hideInfoIcon?: boolean;
}

export const CouponDisplay = ({ coupon, className, loading, hideInfoIcon = false }: Props) => {
  // Función para obtener el contenido del tooltip con la lista de usuarios
  const getSharedUsersTooltipContent = () => {
    if (!coupon?.users || coupon.users.length <= 1) return null;
    const usersList = coupon.users.map((user) => (
      <Fragment key={user.id}>
        <br />
        {user.name} {user.surnames || ''}
      </Fragment>
    ));
    return (
      <>
        Compartido entre:
        <br />
        {usersList}
      </>
    );
  };

  const isShared = coupon?.users && coupon.users.length > 1;

  // Función para obtener el límite de usos, considerando ambos tipos
  const getUsageLimit = () => {
    return coupon?.coupon?.usageLimit || 0;
  };

  return (
    <div className={classNames('coupon-display', className, { loading })}>
      {loading ? (
        <i className='pi pi-spinner pi-spin' />
      ) : (
        coupon && (
          <>
            <Tag
              {...(!coupon.isActive ? { severity: 'warning' } : {})}
              value={
                <>
                  <i className='pi pi-money-bill' />
                  {coupon.coupon.name}
                </>
              }
            />
            <div className='coupon-info'>
              <small
                className={classNames('note', {
                  warning: !coupon.isActive,
                })}
              >
                {coupon.isActive ? `${coupon.usesRemaining} de ${getUsageLimit()} usos restantes` : 'Bono agotado'}
              </small>
              {isShared && (
                <small className='shared-users'>
                  <i className='pi pi-users' />
                  Compartido
                  {!hideInfoIcon && <InfoIcon size='small' content={getSharedUsersTooltipContent()} />}
                </small>
              )}
            </div>
          </>
        )
      )}
    </div>
  );
};
